import { render, staticRenderFns } from "./EmployeesAttendanceApprover.vue?vue&type=template&id=4b24b502"
import script from "./EmployeesAttendanceApprover.vue?vue&type=script&lang=js"
export * from "./EmployeesAttendanceApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports